<template>
    <main class="py-12 space-y-12">
        <section>
            <div class="container lg:columns-2 gap-16">
                <h1>
                    Unsere Melamini Spiellandschaften
                </h1>
                <p class="article-teaser">
                    Hier zeigen wir Ihnen, wo und wie Melamini in unseren Spiellandschaften verarbeitet wird.
                </p>
                <h2 class="h3">
                    Holzarten:
                </h2>
                <p>
                    Douglasie kernfrei, unbehandelt.
                </p>
                <h2 class="h3">
                    Konstruktiver Holzschutz:
                </h2>
                <p>
                    Alle Hölzer sind gefräst bzw. gehobelt und glatt geschliffen. Die sichtbaren Kopfenden der
                    Standhölzer sind mit einer Halbkugelkopffräsung versehen und haben 2 Entlastungsnuten je Längsseite.
                    Alle Kant- und Schnitthölzer sind kerngetrennt.
                    Holz gehört nicht in die Erde verbaut, wir empfehlen aufgrund unserer langjährigen Erfahrung mit dem
                    Produkt Holz im Spielplatzgerätebau, die Aufständerung der Standpfosten mit unserem feuerverzinkten
                    Pfostenschuhsystem.
                </p>
                <h2 class="h3">
                    Verbindungen:
                </h2>
                <p>
                    Alle Verbindungen sind als Schraubverbindungen mit verzinktem Stahl bzw. V2A-Edelstahl verschraubt.
                    Die tragenden Verbindungen sind versenkt und mit einer Kunststoffkappe aus PE-Material
                    verschlossen.
                </p>

                <h2 class="h3">
                    Spieltürme:
                </h2>
                <p>Dreiecktürme, Vierecktürme, Spielpodeste und Stufentürme</p>

                <h2 class="h3 break-before-column">
                    Standpfosten:
                </h2>
                <p>
                    Kantholz 10 x 10 cm<br>
                    Vierkantrohr 10 x 10 cm, pulverbeschichtet
                </p>

                <h2 class="h3">
                    Podestrahmen:
                </h2>
                <p>aus verzinktem Stahl, pulverbeschichtet Stärke 4 mm</p>

                <h2 class="h3">
                    Brüstungsverkleidung:
                </h2>
                <p>HPL oder V2A-Edelstahl</p>

                <h2 class="h3">
                    Böden und Treppenstufen:
                </h2>
                <p>aus HC-Strukturplatte</p>

                <h2 class="h3">
                    Leiteraufstiege:
                </h2>
                <p>Seitenwangen Edelstahl ø 33,7 mm oder HPL, Sprossen aus Edelstahlrohr ø 33,7 mm</p>

                <h2 class="h3">
                    Dächer:
                </h2>
                <p>aus HPL</p>

                <h2 class="h3">
                    Kletternetze/Hangeltaue/Strickleitern:
                </h2>
                <p>
                    Unsere Kletternetze und Hangeltaue bestehen aus 1,6 cm bzw. 2,0 cm starken Polypropylenseilen. Die
                    Litzen sind umlegt in den Farben rot, blau, gelb und grün. Das Seil ist 4-litzig und hat eine 4-fach
                    Stahleinlage von ca. 0,3 mm ø, Bruchkraft 3900 daN.
                </p>

                <h2 class="h3">
                    Rutschen:
                </h2>
                <p>Seitenteile aus HPL, Rutschfläche aus strukturgeprägtem Edelstahlblech 5WL</p>

                <p>Unter der Registerkarte Medien können Sie unsere Materialbeschreibung herunterladen.</p>
            </div>
        </section>

        <section>
            <Carousel/>
        </section>
    </main>
</template>

<script setup lang="ts">
definePageMeta({
    path: '/Material/Melamini',
});

const header = useState<{ title: string; subTitle: string }>(
    'header',
);
header.value = {
    title: 'Eine Welt',
    subTitle: 'voller Stabilität',
};
</script>

<style scoped>

</style>
